import React from "react";
import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardProductivity.css";

const DashboardProductivity = ({ summary = {}, todayTasks = [] }) => {
    const employees = summary.employees ?? 0;
    const working = summary.working ?? 0;

    const openTasks = summary.open_tasks ?? 0;
    const completedToday = summary.completed_today ?? 0;
    const totalKnownTasks = openTasks + completedToday;
    
    const overdueTasks = summary.overdue_tasks ?? 0;

    const taskCompletion =
        totalKnownTasks > 0
            ? Math.round( (completedToday / totalKnownTasks) * 100 )
            : 0;

    const employeeUtilization =
        employees > 0
            ? Math.round( (working / employees) * 100 )
            : 0;

    const onTimeDelivery =
        completedToday + overdueTasks > 0
            ? Math.round( (completedToday / (completedToday + overdueTasks)) * 100 )
            : 0;

    const workloadBalance =
        employees > 0
            ? Math.min(
                100,
                Math.round( (todayTasks.length / employees) * 100 )
            )
            : 0;

    const productivity = [
        {
            title: "Task Completion",
            value: taskCompletion,
            color: "#2563eb",
        },
        {
            title: "Employee Utilization",
            value: employeeUtilization,
            color: "#16a34a",
        },
        {
            title: "On-Time Delivery",
            value: onTimeDelivery,
            color: "#ea580c",
        },
        {
            title: "Today's Workload",
            value: workloadBalance,
            color: "#7c3aed",
        },
    ];

    return (
        <div className="productivity-card">
            <div className="productivity-header">
                <div>
                    <h2>Team Productivity</h2>
                    <p>Current team performance overview.</p>
                </div>

                <button>
                    View Reports
                </button>
            </div>

            <div className="productivity-list">
                {productivity.map((item) => (
                    <div
                        key={item.title}
                        className="productivity-item"
                    >
                        <div className="productivity-top">
                            <span>
                                {item.title}
                            </span>

                            <span
                                style={{
                                    color: item.color,
                                    fontWeight: 700,
                                }}
                            >
                                {item.value}%
                            </span>
                        </div>

                        <div className="progress">
                            <div
                                className="progress-fill"
                                style={{
                                    width: `${item.value}%`,
                                    background: item.color,
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardProductivity;
